import { Container, Row, Col, Image } from 'react-bootstrap'

const SuccessStoryBecky = () => (
    <>
    <div className="section-success-stories-becky">
        <Container>
            <Row>
                <Col md={5} className="text-center">
                    <Image src="../images/7bs/img-testimonial-01.png" alt="Success story Becky" className="img-fluid d-block mx-auto mb-3"/>
                    <p><small><em>Results May Vary From Person To Person <a href="#results-may-vary">*</a></em></small></p>
                </Col>
                <Col md={7}>
                    <div className="testimonial">
                        <h3>Success stories</h3>
                        <p><em>"I've tried so many diets without any lasting success, I was back in my pre-pregnancy jeans in two months! And I've learned how to keep it off."</em></p>
                        <p><em>"My After-After is my family's well-being, one healthy meal and supplement at a time." <a href="#results-may-vary">*</a></em></p>
                        <p>- Becky</p>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx global>{`

            .section-success-stories-becky {
                background: #fff;
                font-size: 20px;
            }

            .section-success-stories-becky .container {
                padding-top: 60px;
                padding-bottom: 60px;
            }

            .section-success-stories-becky .testimonial {
                background: #f3f4f5;
                padding: 30px 30px 10px;
            }

            .section-success-stories-becky h3 {
                font-weight: 700;
                margin-bottom: 30px;
            }

            .section-success-stories-becky a {
                color: #de7621;
            }

            .section-success-stories-becky p {
                margin-bottom: 30px;
            }

            @media (max-width: 767.98px) {

            }

        `}</style>
    </>
);

export default SuccessStoryBecky;